
$(document).ready(function(){

  $('body').on('change', '#cart .quantity__input', function() {
    setTimeout(function() { $('#cart-icon-bubble').addClass('activeCountBtn'); }, 1000);
  });
  
  $('a[href^=\\#]').click(function(){        
    var offset = 70; // <-- change the value here
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - offset
        }, 400);
        return false;
      }
    }
  });
  
  // Footer mobile menu toggle on click heading
  $('footer.footer h4').click(function(){
    $(this).toggleClass('active');
    $(this).parent().find('ul').slideToggle();
  });

  $('.top-scroll').click(function(){
    $('html, body').animate({scrollTop:0}, '300');
  });
  
  // Client review slider
  const swiper = new Swiper('.client-reviews-slider', {        
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {    
      320:{
        slidesPerView: 1.1,
        spaceBetween: 15,
      },
      360:{
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
      575:{
        slidesPerView: 2,
        spaceBetween: 10,
      },
      767:{
        slidesPerView: 2,
        spaceBetween: 20,
      },    
      1024:{
        slidesPerView: 3            
      },    
      1280:{
        slidesPerView: 4, 
        spaceBetween: 40              
      }
    }  
  });

});


// Summary details tag sub-menu
let itemss = document.querySelector(".header__inline-menu").querySelectorAll("details");
  itemss.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });  
});


document.addEventListener('DOMContentLoaded', function() {
  let backShopEle = document.querySelector(".mobile-back-shop");

  if (backShopEle) {
    let backShop = backShopEle.getBoundingClientRect();
  
    window.addEventListener('scroll', function() {
      let scrollTop = window.scrollY; // or window.pageYOffset for older browsers

      if (scrollTop > backShop.y - 45) {
        backShopEle.classList.add('back-shop-fixed');
      } else {
        backShopEle.classList.remove('back-shop-fixed');
      }
    });
  }
});
